import { DateModeEnum as e } from "../types/date-mode-enum.js";
import { setDateWithTimezone as t, toISOStringWithoutTimezone as n } from "../utils/date-utils.js";
import { setDateTill as r } from "../utils/set-date-till.js";
import { useEffect as i, useMemo as a, useState as o } from "react";
//#region src/date-picker/date-picker/use-date.ts
function s({ value: s, mode: c = e.DateSince, timezone: l, onChange: u }) {
	let d = a(() => s ? t(s, l) : null, [s, l]), [f, p] = o(d), [m, h] = o(d);
	return i(() => {
		p(d), h(d);
	}, [d]), {
		appliedDate: m,
		applyDate: (t) => {
			if (!t) {
				p(null), h(null), u(null);
				return;
			}
			let i = new Date(t);
			c === e.DateTill && r(i), p(i), h(i), u(n(i));
		},
		selectedDate: f,
		setSelectedDate: p
	};
}
//#endregion
export { s as useDate };
